/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_Create_TitleInputs */

const cs_clients_tags_create_title = /** @type {(inputs: Clients_Tags_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový štítek`)
};

const en_clients_tags_create_title = /** @type {(inputs: Clients_Tags_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New tag`)
};

/**
* | output |
* | --- |
* | "New tag" |
*
* @param {Clients_Tags_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_create_title = /** @type {((inputs?: Clients_Tags_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_create_title(inputs)
	return cs_clients_tags_create_title(inputs)
});